export default __webpack_public_path__ + "static/media/home-page-first-section.64731061.jpg";